<template>
    <div class="MhExcelViewer">
      <el-tabs :value="activeName" type="card" tab-position="top" class="tab-pane_xlsx">
        <el-tab-pane
          :key="item"
          v-for="item in sheets"
          :label="item"
          :name="item"
          :style="{height: tabHeight_ + 'px',overflow: 'auto'}"
        >
<!--          <div class="top-div">-->
<!--            <div class="top-div1">{{activeCell}}</div>-->
<!--            <div class="top-div2">{{selVal}}</div>-->
<!--          </div>-->
          <div class="tabody">
            <template v-for="(tr, i) in workBooks[item]" >
              <div class="tr-header" :key="item+i">
                <template v-for="cell in tr">
                  <div :class="{'tr-header-cell': true, 'selectCell': activeCell===cell.xy}" :style="{width: cell.width + 'px', height: cell.height + 'px', lineHeight: cell.height + 'px'}"
                       :key="cell.xy" :title="cell.value" @click="selectCell(cell.value, cell.xy)">{{cell.value}}</div>
                </template>
              </div>
            </template>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
export default {
  name: 'MhExcelViewer',
  props: ['sheets', 'workBooks'],
  data () {
    return {
      tabHeight_: 0,
      activeCell: '',
      selVal: ''
    }
  },
  computed: {
    activeName () {
      return this.sheets[0]
    },
    maxWidthBook () {
      const that = this
      const maxWidthBook = {}
      const workBookExt = Object.assign({}, that.workBooks)
      for (const key in workBookExt) {
        const book = workBookExt[key]
        const maxWidth = []
        for (let i = 0; i < book.length; i++) {
          const obj = book[i]
          let j = 0
          for (const kk in obj) {
            let len = 140
            const val = obj[kk]
            if (typeof val === 'string') {
              len = val.length * 10
              if (len > 400) {
                len = 400
              } else if (len < 100) {
                len = 80
              }
            } else {
              len = 80
            }
            if (maxWidth.length <= j) {
              maxWidth[j] = len
            } else {
              if (len > maxWidth[j]) {
                maxWidth[j] = len
              }
            }
            j = j + 1
          }
        }
        let totWidth = 0
        for (let k = 0; k < maxWidth.length; k++) {
          totWidth = totWidth + maxWidth[k]
        }
        maxWidthBook[key] = {
          width: maxWidth,
          totWidth: totWidth + 100
        }
      }
      return maxWidthBook
    }
  },
  methods: {
    selectCell: function (val, xy) {
      this.selVal = val
      this.activeCell = xy
      // this.$parent.title = val
      this.$emit('selectValChange', val)
      // this.$forceUpdate()
    }
  },
  mounted () {
    const that = this
    that.$nextTick(function () {
      that.tabHeight_ = window.innerHeight - 40 - 48
      // 监听窗口大小变化
      window.onresize = function () {
        that.tabHeight_ = window.innerHeight - 40 - 48
      }
    })
  }
}
</script>

<style lang="less" scoped>
  .tabody {
    width: 100%;
    height: 100%;
    overflow: auto;
    display: block;
  }
  .tr-header {
    display: block;
    white-space: nowrap;
  }
  .tr-header-cell {
    margin-bottom: -4px;
    display: inline-block;
    padding-left: 5px;
    white-space: nowrap;
    word-wrap: break-word;
    word-break: break-all;
    border: 1px gray solid;
    text-overflow:ellipsis;
    overflow:hidden;
    color: black;
    font-size: 11px;
    cursor: pointer;
  }
  .top-div {
    position: absolute;
    width: 100%;
    height: 30px;
    border: 1px red solid;
    top: -10px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .top-div1 {
    line-height: 33px;
    width: 60px;
    margin-bottom: -4px;
    display: inline-block;
    padding-left: 5px;
    white-space: nowrap;
    word-wrap: break-word;
    word-break: break-all;
    border: 1px gray solid;
    text-overflow:ellipsis;
    overflow:hidden;
    color: black;
    font-size: 11px;
  }
  .top-div2 {
    min-width: 200px;
    height: 33px;
    line-height: 33px;
    margin-bottom: -4px;
    display: inline-block;
    padding-left: 5px;
    white-space: nowrap;
    word-wrap: break-word;
    word-break: break-all;
    border: 1px gray solid;
    text-overflow:ellipsis;
    overflow:hidden;
    color: black;
    font-size: 11px;
  }
  .selectCell {
    background: antiquewhite;
    border: 1px blue solid;
  }
  /*.tr-header-cell:hover {*/
  /*  background: antiquewhite;*/
  /*  border: 1px blue solid;*/
  /*  height: auto !important;*/
  /*}*/
  .tab-pane_xlsx {
    margin-top: 10px;
  }

</style>
